<template>
  <span class="jm-studytarget-select">
    <jm-dict-select
      class="jm-input135"
      v-bind="$attrs"
      type="online"
      dict-type="studytarget_kr"
      v-model="top"
      @change="changTop"
    />
    <jm-dict-select
      class="jm-input135"
      v-bind="$attrs"
      type="online"
      dict-type="studytarget_kr_sub"
      :refresh.sync="refreshDetail"
      :filter="filter"
      @change="changeSub"
      v-model="sub"
    />
  </span>
</template>

<script>
import educationSelect from './educationSelect';

export default {
  extends: educationSelect,
  name: 'JmStudytargetSelect',
};
</script>
